import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

// Guard voor deelnemersroutes: vereist geldig p11_token.
export default function P11Guard({ children }) {
  const nav = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok
  useEffect(() => {
    const token = localStorage.getItem("p11_token");
    if (!token) { nav("/project11/login", { replace: true }); return; }
    api.get("/project11/me/dashboard")
      .then(() => setState("ok"))
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          localStorage.removeItem("p11_token");
          nav("/project11/login", { replace: true });
        } else setState("ok");
      });
  }, [nav]);
  if (state === "loading") {
    return (
      <div className="p11-root flex items-center justify-center min-h-screen">
        <span className="p11-label" data-testid="p11-guard-loading">PROJECT 11* …</span>
      </div>
    );
  }
  return children;
}
